import SelectDropDown from 'components/SelectDropDown/SelectDropDown';
import { checkIntegrationData } from 'helper/Integration';
import { inject, observer } from 'mobx-react';
import { INTEGRATION } from 'models/Integration';
import React, { useEffect, useState } from 'react';
import { HelpscoutIntegrationStore } from 'stores/integrations/HelpscoutIntegrationStore';
import { ProjectStore } from 'stores/private/ProjectStore';
import './HelpscoutConfiguration.scss';

interface HelpscoutConfigurationProps {
  integrationID: string;
  index: number;
  helpscoutIntegrationStore?: HelpscoutIntegrationStore;
  projectStore?: ProjectStore;
  onChange: (data: any) => any;
}

const HelpscoutConfiguration = ({
  integrationID,
  index,
  helpscoutIntegrationStore,
  projectStore,
  onChange,
}: HelpscoutConfigurationProps) => {
  const project = projectStore?.currentProject;

  const [currentIntegrationInfo, setCurrentIntegrationInfo] = useState(
    {} as any,
  );

  const mailboxes = helpscoutIntegrationStore?.mailboxes;

  const [mailboxID, setMailboxID] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (project && isMounted) {
      initialize();
    }
  }, [project, isMounted]);

  useEffect(() => {
    saveIntegrationInfo();
  }, [mailboxID]);

  const initialize = async () => {
    helpscoutIntegrationStore!.setIntegrationID(integrationID);
    await helpscoutIntegrationStore!.getMailboxes();

    if (
      !checkIntegrationData({
        project,
        integrationName: INTEGRATION.HELPSCOUT,
        integrationID,
        actionIndex: index,
      })
    ) {
      return;
    }

    const integrationInfo =
      project?.integrations?.helpscout[integrationID]?.actions[index]
        ?.integrationInfo;

    setCurrentIntegrationInfo(integrationInfo);
  };

  const saveIntegrationInfo = () => {
    const integrationInfo = {
      mailboxID,
    };

    onChange(integrationInfo);
  };

  return (
    <div className="configuration-container mt-30">
      <SelectDropDown
        className="mb-15"
        label="Mailbox"
        labelPropertyName="name"
        valuePropertyName="id"
        selectedItem={mailboxes.find(
          (element) => element.id === currentIntegrationInfo?.mailboxID,
        )}
        isLoading={mailboxes.length === 0}
        items={mailboxes}
        onChange={(option) => {
          setMailboxID(option.id);
        }}
      />
    </div>
  );
};

export default inject(
  'helpscoutIntegrationStore',
  'projectStore',
)(observer(HelpscoutConfiguration));
